module.exports = __webpack_public_path__ + "assets/img/text-to-speech-case2.15489dfd.png";